import Tag from "@/shared/data-display/tag";
import { CloseOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_ALL_PERSONS_EXTENDED } from "../api/get-all-persons-extended";
import { PersonSelectExtendedProps } from "./person-select-extended";
import { normalizeToArray } from "../utils/normalize-to-array";
import { PersonName } from "@/modules/common/entities/person/person-name";

type PersonSelectExtendedTagsProps = Pick<
  PersonSelectExtendedProps,
  "value" | "onChange"
>;

export function PersonSelectExtendedTags({
  value,
  onChange,
}: PersonSelectExtendedTagsProps) {
  const { data } = useQuery(GET_ALL_PERSONS_EXTENDED);
  const personsData = data?.findPersons?.content ?? [];

  const persons = normalizeToArray(value)
    .map((id) => personsData.find((person) => person.id === id))
    .filter(
      (person): person is NonNullable<typeof person> => person !== undefined,
    );

  const unsetPerson = (personId: string) => {
    if (Array.isArray(value)) {
      onChange?.(value.filter((id) => id !== personId));
    }

    if (personId === value) {
      onChange?.(undefined);
    }
  };

  return (
    <div className="flex flex-wrap gap-1">
      {persons.map((person) => (
        <Tag
          key={person.id}
          className="!mr-0"
          closeIcon={<CloseOutlined />}
          onClose={() => unsetPerson(person.id)}
        >
          <PersonName data={person} />
        </Tag>
      ))}
    </div>
  );
}
